import styled from "@emotion/styled/macro";
import React, { Component, Fragment } from "react";
import { ReactComponent as ArrowOutline } from "Icons/ArrowOutline.svg";
import { FlexWrapperT3 } from "../Wrapper/FlexWrapper";
import { TypographyT39 } from "../Typography/index";
const Button = styled.button`
  margin: 0px;
  box-sizing: border-box;
  font-family: Poppins;

  font-style: normal;
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
  padding: 8px 10px;
  color: #ffffff;
  background-color: #627fe9;
  border-radius: 3px;
  transform: 0.8s all;
  &:hover {
    background-color: rgba(98, 127, 233, 0.8);
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 1px 1px rgba(89, 123, 247, 0.2)"};
  }
  &:active {
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 2px 2px rgba(89, 123, 247, 0.2)"};
  }
  &[disabled] {
    cursor: not-allowed;
    box-shadow: 0px;
    color: #a6a6a6;
    background-color: #e0e0e0;
    box-shadow: 0px;
  }
`;
const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  box-sizing: border-box;
  font-family: Poppins;
  padding: 5px;

  border-radius: 50%;
  transform: 0.8s all;
  &:hover {
    background-color: rgba(98, 127, 233, 0.2);
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 1px 1px rgba(89, 123, 247, 0.2)"};
  }
  &:active {
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 2px 2px rgba(89, 123, 247, 0.2)"};
  }
  &[disabled] {
    cursor: not-allowed;
    box-shadow: 0px;
    color: #a6a6a6;
    background-color: #e0e0e0;
    box-shadow: 0px;
  }
`;

export const ButtonT1 = styled(Button)`
  background-color: transparent;
  color: #528aea;
  font-size: 20px;
  font-weight: 500;

  &:hover {
    background-color: rgba(98, 127, 233, 0.1);
  }
`;
// outlined button
export const ButtonT2 = styled(Button)`
  color: #627fe9;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  border-radius: 5px;
  border: 1px solid #627fe9;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  &:hover {
    background-color: inherit;
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 1px 1px rgba(89, 123, 247, 0.2)"};
    opacity: 0.8;
  }
  min-height: 40px;
  min-width: 120px;
`;

// ghost button
export const ButtonT3 = styled(Button)`
  background-color: inherit;
  &:hover {
    background-color: inherit;
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 1px 1px rgba(89, 123, 247, 0.2)"};
    opacity: 0.8;
  }
`;

export const ButtonT4 = styled(Button)`
  color: #528aea;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(25, 25, 25, 0.3);
  padding-top: 10px;
  padding-bottom: 10px;
  &:hover {
    background-color: #f2f5fc;
  }
`;

export const IconButtonT1 = styled(IconButton)`
  background: inherit;
`;

export const BackButtonT1 = (props) => {
  return (
    <Fragment>
      <ButtonT1 {...props}>
        <FlexWrapperT3>
          <ArrowOutline fill={"#528AEA"} width={"24px"} />
          Back
        </FlexWrapperT3>
      </ButtonT1>
    </Fragment>
  );
};

export const ButtonT5 = styled(Button)`
  background-color: ${({ active }) => (!!active ? "#627fe9" : "#ffffff")};
  color: ${({ active }) => (!!active ? "#ffffff" : "#627fe9")};
  &:hover {
    background-color: ${({ active }) => (!!active ? "#627fe9" : "#ffffff")};
    opacity: 0.8;
  }
  width: ${({ width }) => (!!width ? width : "")};
  min-width: ${({ minWidth }) => (!!minWidth ? minWidth : "")};
`;
export const ButtonGroup = styled("div")`
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #627fe9;
  & > ${ButtonT5} {
    border-radius: 0px;
    border-left: 1px solid #627fe9;
  }
  & > ${ButtonT5}:first-of-type {
    border-left: 0px solid #627fe9;
  }
  width: fit-content;
`;
export const ButtonT6 = styled(Button)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  line-height: 18px;
  background-color: inherit;
  font-weight: ${({ active }) => (!!active ? "600" : "400")};
  position: relative;

  &:hover {
    background-color: inherit;
    opacity: 0.8;
  }
  &::before {
    visibility: ${({ active }) => (!!active ? "visible" : "hidden")};
    content: "";

    border: 2px solid #627fe9;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(2px);
  }
`;
export const TabButtonGroup = styled("div")`
  border-bottom: 1px solid #48525e;
  & > ${ButtonT6} {
    border-radius: 0px;
  }
`;
export const ButtonT7 = styled(ButtonT2)`
  border: 1px solid #627fe9;
  background: #627fe9;
  color: #fff;

  &:hover {
    background-color: #627fe9;
    color: #fff;
    box-shadow: ${({ disabled }) =>
      !!disabled ? "0px" : "0px 0px 1px 1px rgba(89, 123, 247, 0.2)"};
    opacity: 0.8;
  }
`;
export const ButtonT8 = styled(ButtonT2)`
  border-radius: 0px;
  border: 0px;
  border-left: 1px solid #627fe9;
`;

export const FileUploadButtonT1 = (props) => {
  const { fileName, ...rest } = props;
  return (
    <Fragment>
      <FileUploadButtonT1Wrapper>
        <FileInput type="file" {...rest} />
        <TypographyT39>{!!fileName ? fileName : "File Name"}</TypographyT39>
        <ButtonT8>Browse</ButtonT8>
      </FileUploadButtonT1Wrapper>
    </Fragment>
  );
};

export const FileInput = styled("input")`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // max-height: 40px;
  // min-height: 40px;
  // min-width: 380px;
`;
export const FileUploadButtonT1Wrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: 40px;
  min-height: 40px;
  min-width: 380px;
  border-radius: 5px;
  border: 1px solid #627fe9;
  background: #fff;
  overflow: hidden;
  position: relative;
  padding-left: 10px;
  &::before {
    position: absolute;
    content: "";
    width: 20px;
    height: 8px;
    background-color: inherit;
    top: 0;
    left: 0;
    z-index: 1;
  }
`;

export const ButtonT9 = styled(ButtonT3)`
  display: flex;
  gap: 10px;
`;

// contained

export const ButtonT10 = styled(Button)`
  background-color: #627fe9;
  color: #ffffff;
  &:hover {
    opacity: 0.8;
  }
`;

// outline button T1

export const ButtonT11 = styled(ButtonT2)`
  font-size: 12px;
  color: #42569e;
  padding: 2px;
  min-width: fit-content;
  min-height: fit-content;
`;


// contained button T1

export const ButtonT12 = styled(ButtonT10)`
  background-color: #627fe9;
  color: #ffffff;
  font-size: 14px;
  &:hover {
    opacity: 0.8;
  }
  padding: 4px 8px;
  width:max-content;
`;